import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  trainingSetItemList: {
    // border: `1px solid ${theme.palette.border.main}`,
    // borderRadius: '10px',
    overflow: 'hidden',
    margin: theme.spacing(1, 0, 0),
  },
  trainingSetItemListHeader: {
    minHeight: theme.spacing(5),
    padding: theme.spacing(0.5, 1),
    backgroundColor: theme.palette.background.default,
    alignItems: 'center',
    borderRadius: '2px 2px 0 0',
    borderBottom: `1px solid ${theme.palette.border.main}`,
  },
  selectorWithContent: {
    '& .MuiOutlinedInput-root': {
      minHeight: '48px',
    },
  },
  headerTextWrapper: {
    minWidth: 0,
    textTransform: 'capitalize',
    whiteSpace: 'normal',
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
    padding: theme.spacing(0, 0.5, 0, 0),
  },
  trainingSetProgressContainer: {
    height: '4px',
    borderRadius: '2px',
    backgroundColor: theme.palette.secondary.main,
    margin: theme.spacing(1, 2, 2),
    overflow: 'hidden',
    display: 'flex',
  },
  trainingSetProgress: {
    height: '4px',
    transition: 'max-width 0.7s ease-out',
    width: '100%',
  },
  trainingSetProgressCompleted: {
    background:
      (theme.palette as { primaryGradient?: string }).primaryGradient ??
      theme.palette.primary.main,
  },
  trainingSetProgressDoLate: {
    background: theme.palette.warning.main,
  },
  trainingSetProgressSkipped: {
    background: theme.palette.error.main,
  },
  fireIcon: {
    width: theme.spacing(2),
    height: theme.spacing(2),
    color: theme.palette.warning.main,
  },
  trainingSetHeader: {
    padding: theme.spacing(1, 2, 0),
  },
  trainingSetFooter: {
    margin: theme.spacing(1, 0),
    padding: theme.spacing(0, 2),
  },
}));
